module.exports = __webpack_public_path__ + "static/media/corncob.649ccc7e.svg";